import { useState } from "react";
import styles from "./login.module.css";
import logo from "../../../images/_finais/header-logo_compress.webp";
import { ILogin } from "../../../interfaces/login";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  onClickLogin: (input: ILogin) => Promise<void>;
};

const Login = ({ onClickLogin }: Props) => {
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState<ILogin>({
    email: null,
    password: null,
  });

  const onChangeEmail = (email: string) => {
    if (email !== null) setLogin({ ...login, email });
  };

  const onChandePassword = (password: string) => {
    if (password !== null) setLogin({ ...login, password });
  };

  const handleLoginClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onClickLogin(login);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginBox}>
      <div className={styles.header}>
        <h1 className={styles.title}>Login</h1>
        <img className={styles.logo} src={logo} alt="Logo TruEvidence" />
      </div>

      <form className={styles.loginForm}>
        <input
          className={styles.input}
          type="text"
          placeholder="E-mail"
          onChange={(event) => onChangeEmail(event.target.value)}
        />
        <input
          className={styles.input}
          type="password"
          placeholder="Senha"
          onChange={(event) => onChandePassword(event.target.value)}
        />
        <button
          className={styles.loginBtn}
          onClick={handleLoginClick}
          disabled={loading}
        >
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} className={styles.spinner} />
          ) : (
            "Entrar"
          )}
        </button>
      </form>
    </div>
  );
};

export default Login;
